import { all } from "redux-saga/effects";
import { appSagas } from "./functions/App";
import { authSagas } from "./functions/Auth";
import { campaignSagas } from "./functions/Campaign";

export default function* rootSaga() {
  yield all([...appSagas, ...authSagas, ...campaignSagas]);
}
